
$(document).ready(function(){
    $("#product_type").on("change", "input:checkbox", function(){
      $("#product_type").submit();
    });
  });

// for sorting

$(document).ready(function () {
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split("&");

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split("=");

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] =
          decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector("#sortby").addEventListener("change", function (e) {
    var value = e.target.value;

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
});

// for single product 
$(document).ready(function(){
  
  jQuery('input[type=radio]').on('change', function() {
            // console.log($(this).val());
          setTimeout(function() {
            set_variant();
          }, 100);
        });
    
    function  set_variant(){
       var newar=[];            
        jQuery(document).find('input[type=radio]:checked').each(function(){
          if(jQuery(this).closest('.product-form__input').length>0){
            newar.push(jQuery(this).val());
            // console.log(newar)
          }
        })
             if(newar.length > 0){
            var thisvals = newar.join(' / ');
            jQuery('.myclass').find('option').each(function(){
              var variant_val = $(this).val();
              var variant_id = $(this).attr("data-id");
              var variant_price = $(this).attr("price");
              var variant_quantity = $(this).attr("data-qty");
              var variant_sku = $(this).attr("var-sku");
              var variant_compareatprice = $(this).attr("compare-at-price");
              if($(this).data('title') == thisvals){
              jQuery('.myclass').val($(this).attr('value'));
              var selcted_val = jQuery('.myclass').val();
             var variantId =   $(this).closest('.collection-page-form').find('.add_to_cart').attr('variant-id', $(this).attr('value'));
              var price = $(this).attr('data-price');
              var variant_price = $(this).attr('data-price');
              var variant_title = $(this).attr('sku');
              var variant_cmp_price  = $(this).attr('data-cmp-price');
             }
          })
        }
      }

  
      $(document).on('click', '.add_to_cart', function(e){
        e.preventDefault();
        var variant_id = $(this).attr('variant-id');
        // var qty =  parseInt( $('.qtyValue').text());
        var qty =  1;
        // var items = [];
// console.log(variant_id, qty )

        
         addToCart(variant_id,qty)
        var shop_url = window.origin;
    });
  });


 function addToCart(variant_id,qty){
        var shop_url = window.origin;
        
        $.post(shop_url+"/cart/add.js", { id: variant_id,quantity:qty}, function(result){
          location.href = '/cart';
        });
      }
//-------------------------header-sticky-js-start--------------
    $(window).scroll(function(){
        if ($(this).scrollTop() > 90) {
            $('header').addClass('sticky-header');
        } else {
            $('header').removeClass('sticky-header');
        }
    });
//------------------------header-sticky-js-end------------------

//--------------------------toggle-btn-js------------------------
    $(".navbar-toggler").click(function(){
        $(this).toggleClass('navbar-closed');
        $("html").toggleClass("myClass");
      });

    $(".description-box span").click(function(){
        $(".description-box").toggleClass("show");
      });
   
    $(document).ready(function(){
     if ($(window).width() < 767) {
             $(".filter-head").click(function(){
                $(".filter-box").toggleClass("show");
                $("html").toggleClass("myClassone");
              });
        } 
    });


    $(".contact-form .form-group").click(function(){
      $('.contact-form .form-group').not(this).removeClass('active');
      $(this).toggleClass('active');
    }); 
//-----------------------toggle-btn-js------------------------


// ---------------------body-close-event-js-start---------------------
    $(document).on('click', function(event) {
      if (!$(event.target).closest('.filter-box').length) {
        $('.filter-box').removeClass('show');
        $("html").removeClass("myClassone");
      }
    });
// ---------------------body-close-event-js-end-----------------------

//----------------------active-class-js-start-----------------
    //  jQuery(function($) {
    //     var path = window.location.href; 
    //     $('header a.nav-link').each(function() {
    //     if (this.href === path) {
    //     $(this).addClass('active');
    //       }
    //     });
    // });
//----------------------active-class-js-end-------------------



//-----------------------owl-js-start--------------------------

    $('.banner_slider').owlCarousel({
        items:1,
        loop:true,
        margin:0,
        nav:true,
        navText:['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
        dots:true
    });

    $('.testimonial_slider').owlCarousel({
        items:1,
        loop:true,
        margin:0,
        nav:true,
        navText:['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
        dots:true
    });

    $('.brand_slider').owlCarousel({
        items:4,
        loop:true,
        margin:30,
        nav:true,
        navText:['<i class="fa-solid fa-arrow-left"></i>', '<i class="fa-solid fa-arrow-right"></i>'],
        dots:true,
        responsive:{
            0:{
                items:2, 
                margin:15
            },
            600:{
                items:3
            },
            1000:{
                items:4
            }
        }
    });


   $(document).ready(function() {
      var bigimage = $("#single_product");
      var thumbs = $("#thumbs");
      //var totalslides = 10;
      var syncedSecondary = true;

      bigimage
        .owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false,
        dots: false,
        loop: true,
        responsiveRefreshRate: 200,
        navText: [
          '<i class="fa-solid fa-arrow-left"></i>',
          '<i class="fa-solid fa-arrow-right"></i>'
        ]
      })
        .on("changed.owl.carousel", syncPosition);

      thumbs
        .on("initialized.owl.carousel", function() {
        thumbs
          .find(".owl-item")
          .eq(0)
          .addClass("current");
      })
        .owlCarousel({
        items: 5,
        dots: false,
        nav: true, 
        margin:35,       
        smartSpeed: 2000,
        slideSpeed: 2000,
        slideBy: 1,
        responsiveRefreshRate: 100, 
        navText: [
          '<i class="fa-solid fa-arrow-left"></i>',
          '<i class="fa-solid fa-arrow-right"></i>'
        ], 
        responsive:{
            0:{
                items:4, 
                margin:18
            },
            600:{
                items:5, 
                margin:15
            },
            900:{
                items:4,
                margin:20
            },
            1200:{
                items:5,
                margin:15
            },
            1600:{ 
                margin:35
            }
        }
      })
        .on("changed.owl.carousel", syncPosition2);

      function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
          current = count;
        }
        if (current > count) {
          current = 0;
        }
        //to this
        thumbs
          .find(".owl-item")
          .removeClass("current")
          .eq(current)
          .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
        .find(".owl-item.active")
        .first()
        .index();
        var end = thumbs
        .find(".owl-item.active")
        .last()
        .index();

        if (current > end) {
          thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
          thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
      }

      function syncPosition2(el) {
        if (syncedSecondary) {
          var number = el.item.index;
          bigimage.data("owl.carousel").to(number, 100, true);
        }
      }

      thumbs.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        bigimage.data("owl.carousel").to(number, 300, true);
      });
    });

//-----------------------owl-js-end---------------------------


//-----------------------video-section-js-start--------------------------
 
    const video = document.getElementById("video");
    const circlePlayButton = document.getElementById("circle-play-b");

    function togglePlay() {
        if (video.paused || video.ended) {
            video.play();
        } else {
            video.pause();
        }
    }

    circlePlayButton.addEventListener("click", togglePlay);
    video.addEventListener("playing", function () {
        circlePlayButton.style.opacity = 0;
    });
    video.addEventListener("pause", function () {
        circlePlayButton.style.opacity = 1;
    });
    
//-----------------------video-section-js-end----------------------------

//-------------------------------counter-js-start-------------------------

    $('.counter').each(function() {
        var $this = $(this),
            countTo = $this.attr('data-count');
        
        $({ countNum: $this.text()}).animate({
          countNum: countTo
        },
        {
          duration: 1000,
          easing:'linear',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
            //alert('finished');
          }
        }); 
      });

//-------------------------------counter-js-end--------------------------



